export const MIN_SCHEDULE_LEAD_MS = 2 * 60 * 1000;

export function isScheduledAtTooSoon(scheduledAt: string | Date, now: Date): boolean {
  const scheduledMs = scheduledAt instanceof Date
    ? scheduledAt.getTime()
    : Date.parse(scheduledAt);
  if (!Number.isFinite(scheduledMs)) return true;
  return scheduledMs < now.getTime() + MIN_SCHEDULE_LEAD_MS;
}
